import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const SectionMarker = styled(Row)`
  height: 1px;
  max-height: 1px;
  min-height: 1px;
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const ShortSeparatorContainer = styled(Row)`
  width: 432px;
`;
